import { useSyncExternalStore } from 'react';

export interface DepartmentLocale {
  language: 'en' | 'ar';
  t: <T>(value: T) => T;
  format: (template: string, values: readonly unknown[]) => string;
}

// Shared portals live above the department provider. Publish display helpers
// without importing a department's full translation catalog into the app shell.
let active: DepartmentLocale | null = null;
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
const snapshot = () => active;
const serverSnapshot = () => null;
export function publishDepartmentLocale(locale: DepartmentLocale | null) {
  if (active === locale) return;
  active = locale;
  listeners.forEach(listener => listener());
}
export function useDepartmentLocale() {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot);
}
